import React from "react"

const AppWindow = () => (
  <svg
    width="37"
    height="32"
    viewBox="0 0 37 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    focusable="false"
  >
    <path d="M33.709 1.104H3.927a2.29 2.29 0 00-2.291 2.29v25.2a2.29 2.29 0 002.29 2.292H33.71A2.291 2.291 0 0036 28.595v-25.2a2.291 2.291 0 00-2.29-2.291zM1.636 7.976H36M10.8 1.103v6.873m6.872-6.873v6.873" />
    <path d="M18.817 26.304a3.436 3.436 0 100-6.873 3.436 3.436 0 000 6.873zM7.363 24.012h2.29m1.064-8.1l1.872 1.872m6.229-5.226v2.291m6.872 1.145l-4.442 4.443m9.024 3.575h-2.29" />
  </svg>
)

export default AppWindow
